import $ from 'jquery';
/**
 * Enables the "navigation bar" functionality.
 */
const enableNavigationBarFunctionality = () => {
    /**
     * The current path.
     */
    const currentPath = _trimQuerystring(window.location.pathname);
    // Highlight the link in the navigation bar that corresponds to the current path
    $('.nav-link').each(function () {
        const $link = $(this);
        if (currentPath === _trimQuerystring($link.attr('href') || '')) {
            $link.addClass('active');
        }
    });
    /**
     * Trims a URL of its query string.
     * @param url - The URL.
     * @returns The trimmed URL.
     */
    function _trimQuerystring(url) {
        return url.replace(/\?.*$/, '');
    }
};
export default enableNavigationBarFunctionality;
